// Von Chat Type Definitions
export interface VonSession {
  id: string;
  title: string;
  created_at: string;
  updated_at: string;
  message_count: number;
  last_message_preview?: string;
}

export interface VonMessage {
  id: string;
  session_id: string;
  role: 'user' | 'assistant';
  content: string;
  model_used?: string;
  processing_time_ms?: number;
  created_at: string;
  metadata?: {
    filters_applied?: VonChatFilters;
    search_results_count?: number;
    tokens_used?: number;
  };
}

export interface VonChatFilters {
  dateRange?: {
    startDate: string;
    endDate: string;
    preset?: '7days' | '14days' | '30days' | 'custom';
  };
  selectedClients?: string[];
  useNeuralSearch: boolean;
  precisionSearchQuery?: string;
  selectedModel?: VonModelType;
  rawChatMode: boolean;
}

export type VonModelType = 'A1' | 'A2' | 'A3' | 'A4' | 'A5' | 'A6' | 'A7' | 'A8' | 'L1' | 'L4' | 'L5' | 'L6' | 'Z1' | 'Z3' | 'Z4';
export interface VonModelConfig {
  id: VonModelType;
  name: string;
  tier: 'Fast' | 'Premium' | 'Research';
  description: string;
  contextLength: string;
  costTier: '$' | '$$' | '$$$';
  bestFor: string[];
}

export interface VonClient {
  id: string;
  name: string;
  transcript_count: number;
  last_interaction: string;
}

export interface VonChatState {
  sessions: VonSession[];
  currentSession: VonSession | null;
  messages: VonMessage[];
  isLoading: boolean;
  isCreatingSession: boolean;
  error: string | null;
  filters: VonChatFilters;
  availableClients: VonClient[];
  lastRequestTime: number;
  requestCount: number;
  rateLimitReset: number;
}

export const RATE_LIMIT_CONFIG = {
  MAX_REQUESTS_PER_MINUTE: 10,
  MIN_REQUEST_INTERVAL_MS: 1000,
  BURST_LIMIT: 3,
  KV_CACHE_TTL: 300,
};

export const DEFAULT_FILTERS: VonChatFilters = {
  useNeuralSearch: true,
  precisionSearchQuery: undefined,
  selectedModel: undefined,
  dateRange: undefined,
  selectedClients: [],
  rawChatMode: false
};
